/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyDiscountTypesDropdown200,
  GetApiV1AssociatedcompanyDiscountTypesDropdown401,
  GetApiV1AssociatedcompanyDiscountTypesDropdown500,
  GetApiV1AssociatedcompanyDiscountTypesDropdownQueryParams,
  GetApiV1AssociatedcompanyDiscountTypesDropdownQueryResponse,
} from "../../types/associatedCompanySharedController/GetApiV1AssociatedcompanyDiscountTypesDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1AssociatedcompanyDiscountTypesDropdownQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1AssociatedcompanyDiscountTypesDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyDiscountTypesDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1AssociatedcompanyDiscountTypesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyDiscountTypesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyDiscountTypesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyDiscountTypesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyDiscountTypesDropdown500>;

export const getApiV1AssociatedcompanyDiscountTypesDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1AssociatedcompanyDiscountTypesDropdown200Schema,
  ) as unknown as ToZod<GetApiV1AssociatedcompanyDiscountTypesDropdownQueryResponse>;
